<dspx-spinner></dspx-spinner>
<dspx-header [config]="headerConfig" [showMenu]="false"></dspx-header>

<div class="p-col">
  <div class="p-col">
    <dspx-environment-banner [message]="environmentBannerMessage"
                             [bgcolor]="environmentBannerBgColor"
                             [color]="environmentBannerColor"
                             [topDividerDisplay]="'never'"
                             [bottomDividerDisplay]="'auto'">
    </dspx-environment-banner>
    <router-outlet></router-outlet>
  </div>
</div>

<dspx-footer [config]="footerConfig"></dspx-footer>
